import { CustomThemeConfig } from 'tailwindcss/types/config';

export const colors: CustomThemeConfig['extend'] = {
  colors: {
    wf: '#fdfdfd',
    main_black: '#000000',
    main_white: '#FFFFFF',
    main_green: '#18AB86',
    main_blue: '#0099FF',
    main_dark_blue: '#0E47C0',
    main_yellow: '#FFDA2B',
    main_light_blue: '#98D4F2',
    general_MI_500_default: '#00BA88',
    general_MI_600_hover: '#00A97B',
    general_MI_700_pressed: '#008A65',
    general_MI_800_disabled: '#333333',
    general_MI_50: '#24F1BA80',
    general_MI_300: '#24F1BA',
    general_MI_750_toggle_default: '#52545D',
    general_MI: '#2E6F5E',
    general_text_MII_default: '#F8F8FB',
    general_text_MII_dark: '#191B20',
    general_text_MII_hover: '#DFDFDF',
    general_text_MII_disabled: '#616161',
    general_text_MII_secondary_i: '#6E718F',
    general_text_MII_secondary_ii: '#A1A2A8',
    general_text_MII_secondary_iii: '#BABABA',
    general_background_MIII_400_dark: '#383A42',
    general_background_MIII_450_dark: '#292929',
    general_background_MIII_500_dark: '#202020',
    general_background_MIII_600_dark: '#191B20',
    general_background_MIII_500: '#F7F7FC',
    general_background_MIII_600: '#E8E9F1',
    general_background_MIII_700: '#D9DBE9',
    general_ico_MIV_500_default: '#F8F8FB',
    general_ico_MIV_500_disabled: '#616161',
    general_ico_MIV_500_hover: '#DFDFDF',
    secondary_error_SI_400_error: '#D54972',
    secondary_success_SI_400_success: '#32E3B3',
    secondary_warning_SI_400_warning: '#F6CC6B',
    secondary_error_SI_500_error: '#C20052',
    secondary_success_SI_500_success: '#00BA88',
    secondary_warning_SI_500_warning: '#E3931B',
    secondary_error_SI_600_error: '#851E3D',
    secondary_success_SI_600_success: '#00966D',
    secondary_warning_SI_600_warning: '#A97613',
    'border-static': 'rgba(110, 113, 143, 0.24)',
  },
};
